export const TEST_IDS = {
  optionActionsButtonGroup: 'option-actions-button-group',
  optionReviewButtonGroup: 'option-review-button-group',
}
